import { Button, Row, Col } from 'antd';
import { useNavigate } from 'react-router-dom';
import './index.less';
import { useSelector } from 'react-redux';

export default function Index() {
  const Navigate = useNavigate();
  const { userType } = useSelector((state) => state);

  const isEnterpriseUser = userType === 3;

  function handleChange(type) {
    Navigate(`/supplyChain/project?type=${type}`);
  }

  return (
    <div className="supply-chain-finance">
      <div className="supply-chain-finance__banner">
        产业链金融
      </div>
      <Row className="content-width btn-row">
        {isEnterpriseUser && (
          <>
            <Col span={8}>
              <Button type="primary" onClick={() => handleChange(1)}>链主企业申报入口</Button>
            </Col>
            <Col span={8}>
              <Button type="primary" onClick={() => handleChange(2)}>链属企业申报入口</Button>
            </Col>
          </>
        )}
        <Col span={isEnterpriseUser ? 8 : 24}>
          <Button type="primary" onClick={() => handleChange(3)}>相关经营主体申报入口</Button>
        </Col>
      </Row>
    </div>
  );
}
